import React from 'react'
import styled from 'styled-components'

const Container = styled.nav`
  font-size: 24px;
  line-height: 32px;

  > a {
    margin-left: 20px;

    text-decoration: none;

    &:first-child {
      margin-left: 0;
    }
  }

  @media (max-width: 760px) {
    font-size: 20px;
  }
`

const Socials = () => (
  <Container>
    <a href="mailto:maxim.beaudoin@gmail.com">Mail</a>
    <a href="https://github.com/maxisix" target="_blank">
      Github
    </a>
    <a href="https://medium.com/@maximebeaudoin" target="_blank">
      Medium
    </a>
    <a href="https://www.linkedin.com/in/mabeaudoin/" target="_blank">
      LinkedIn
    </a>
  </Container>
)

export default Socials



// WEBPACK FOOTER //
// ./src/components/Socials.js